import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles(theme => ({
    paperMembership: {
        padding: theme.spacing(3)
    },
    section: {
        marginTop: theme.spacing(3)
    },
    sectionCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
})
)

export default function DetailSkelton() {

    const classes = useStyles()

    return (
            <Paper className={classes.paperMembership}>
                <>
                    <div className={classes.sectionCenter}>
                        <Skeleton height={30} width="20%" animation="wave" />
                    </div>
                    <div className={classes.section}>
                        <Skeleton height={20} width="20%" animation="wave" />
                        <Skeleton height={15} width="80%" animation="wave" />
                    </div>
                    <div className={classes.section}>
                        <Skeleton height={20} width="20%" animation="wave" />
                        <Skeleton height={15} width="15%" animation="wave" />
                        <Skeleton height={15} width="15%" animation="wave" />
                    </div>
                    <div className={classes.section}>
                        <Skeleton height={20} width="20%" animation="wave" />
                        <Skeleton height={15} width="15%" animation="wave" />
                        <Skeleton height={15} width="15%" animation="wave" />
                        <Skeleton height={15} width="15%" animation="wave" />
                    </div>
                    <div className={classes.section}>
                        <Skeleton height={20} width="20%" animation="wave" />
                        <Skeleton height={15} width="80%" animation="wave" />
                    </div>
                </>
            </Paper>
    )
}